



















































































































































































import { defineComponent, toRefs, ref, onUnmounted } from '@vue/composition-api';
import { RollbackIcon, DeleteIcon, UserIcon } from 'tdesign-icons-vue';

// 引入组件
import errList from '@/renderer/components/dialog/errList.vue';
import conflictDialog from '@/renderer/components/dialog/conflict.vue';
import Menu from '@/renderer/components/Menu/Menu.vue';
import MenuItem from '@/renderer/components/Menu/MenuItem.vue';
import RefreshableHeader from '@/renderer/components/SpacePage/components/RefreshableHeader.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';

// 引入 compositions
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

// 引入工具类
import { SMH } from '@/renderer/scripts/smh';
import ipc from '@/renderer/scripts/utils/ipc';
import initList from '../compositions/listHandler';
import handleRowDetail from '../compositions/fileDetailHandler';
export default defineComponent({
  components: {
    errList,
    conflictDialog,
    Menu,
    MenuItem,
    UserIcon,
    RollbackIcon,
    DeleteIcon,
    StatusTag,
    RefreshableHeader,
  },
  props: {
    isPersonal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    // 解构 props
    const {
      tableData,
      loading: tableLoading,
      loadingOnHeader,
      methods: initMethods,
      columns,
      loadingStatus,
      sort,
      totalNum,
    } = initList();
    const {
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      hoverIndex,
      methods: listOperateMethods,
    } = listOperateHandler(tableData);
    const {
      show: showDetail,
      methods: detailMethods,
      data: detailData,
      detailType,
      loading: detailLoading,
    } = handleRowDetail();

    const resizeColumns = ref(setResizableColumns(columns));

    const recycleRefresh = () => {
      initMethods.refresh();
    };
    const silentRecycleRefresh = () => {
      initMethods.silentRefresh();
    };
    const recycleFileScope = (data: any) => {
      // 这个方法传过来的数据，都是用来筛选的数据
      initMethods.pullList('pull', data);
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.RECYCLE_REFRESH, recycleRefresh);
    ipc.on(ipc.RENDERER_EVENTS_MAP.RECYCLE_FILE_SCOPE, recycleFileScope);
    const getRecycleDetail = async (item: SMH.RecycledListItemInfo) => {
      await detailMethods.viewDetail(item);
    };
    const onOperateEventProxy = (command: string, item: SMH.RecycledListItemInfo) => {
      const recycledItems = item ? [item] : tableData.selectedList;
      switch (command) {
        case 'detail':
          // 详情展示必须是点击悬浮按钮的，只需要item
          getRecycleDetail(item);
          break;
        case 'restore': {
          showDetail.value = false;
          initMethods.onRestore(tableData.canRestoreFiles);
          reporter.report('restore');
          break;
        }
        case 'delete': {
          initMethods.onDelete(recycledItems, tableData.canDeleteFiles.length);
          reporter.report('delete_completely');
          break;
        }
        default:
          break;
      }
    };
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.RECYCLE_REFRESH, recycleRefresh);
      ipc.off(ipc.RENDERER_EVENTS_MAP.RECYCLE_FILE_SCOPE, recycleFileScope);
    });
    return {
      ...toRefs(tableData),
      sort,
      resizeColumns,
      tableLoading,
      initMethods,
      loadingStatus,
      totalNum,
      detailLoading,
      loadingOnHeader,
      showDetail,
      detailData,
      detailType,
      onOperateEventProxy,
      operateShowMap,
      isFirstButtonHover,
      isSecondButtonHover,
      hoverIndex,
      listOperateMethods,
      recycleRefresh,
      silentRecycleRefresh,
    };
  },
});
